import React, {useState, useEffect} from 'react';

import axios from 'axios';

import {
    Leaderboard,
    OverallLeaderboard,
    TeamLeaderboard,
    Search,
} from '../components';

import Logo from '../../img/logo.png';

import Regel1 from '../../img/regel-1.jpg';
import Regel2 from '../../img/regel-2.jpg';
import Regel3 from '../../img/regel-3.jpg';

import moment from "moment";

import Authenticator from "../components/Authenticator";

import ActivityDropdown from "../components/ActivityDropdown";

function Home() {

    const [segments, setSegments] = useState([]);

    const [searchString, setSearchString] = useState('');

    useEffect(() => {

        axios.get(`/api/segments`)
            .then(result => setSegments(result.data));

    }, []);

    return (

        <div className={'container-fluid'}>

            <div className="row header align-items-center justify-content-center mb-5">
                <div className="col-sm-6">
                    <img src={Logo} alt=""/>
                </div>
            </div>

            <div className="container">

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <ul>
                            <li><a href="#meisterschaften">Was sind die Schwäbischen Meisterschaften im
                                Bergzeitfahren?</a></li>
                            <li><a href="#teilnahme">Wie nehme ich teil?</a></li>
                            <li><a href="#teamwertung">Wie funktioniert die Teamwertung?</a></li>
                            <li><a href="#corona">Warum ist das wichtig während der Corona-Krise?</a></li>
                            <li><a href="#regelwerk">Regelwerk</a></li>
                            <li><a href="#gesamtwertung">Gesamtwertung</a></li>
                            <li>Segmente</li>
                        </ul>

                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <h3 id={'meisterschaften'}>Was sind die Schwäbischen Meisterschaften im Bergzeitfahren?</h3>

                        <p>Ein virtuell ausgewerteter Radsport-Wettbewerb zur Ermittlung der
                            schnellsten BergfahrerInnen und Teams im Schwabenland. Aufgrund der Kontaktbeschränkung durch COVID-19 können
                            wir unsere Rennen nicht wie gewohnt in Gemeinschaft austragen. Die Sportlichkeit und Fitness
                            soll aber nicht leiden. <br/>
                            Sechs Wochen lang kommunizieren wir jede Woche ein neues Strava-Segment, auf dem wir uns messen. Entsprechend deiner
                            Platzierung vergeben wir Punkte nach umgekehrter Platzierung, die wir zu einer Gesamtwertung summieren.</p>
                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <h3 id={'teilnahme'}>Wie nehme ich teil?</h3>

                        <ul>
                            <li>Jeden Freitag veröffentlichen wir ein Segment auf <a
                                href="https://www.facebook.com/Kesseln.cc">Facebook</a>, <a
                                href="https://www.instagram.com/kesseln.cc/">Instagram</a> und <a
                                href="https://www.strava.com/clubs/kesseln">Strava</a></li>
                            <li>Du hast neun Tage Zeit, das Segment zu fahren</li>
                            <li>Nach jeder Fahrt trägst du hier ganz einfach deine Leistung ein: Mit Strava verbinden, Fahrt auswählen und die beste Segment-Leistung wird in die Wertung aufgenommen.</li>
                            <li>Fährst du das Segment später nochmal, kannst du genauso deine Wertung aktualisieren.</li>
                            <li>Ein Strava Abonnement ist nicht nötig.</li>
                            <li>Für deine Platzierung vergeben wir Punkte entsprechend deiner umgekehrten
                                Platzierung. Mehr Teilnehmer, mehr Punkte – und der Letzte kriegt auch noch was.
                            </li>
                            <li>Der Wettbewerb endet nach sechs Segmenten</li>
                        </ul>

                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <h3 id={'teamwertung'}>Wie funktioniert die Teamwertung?</h3>

                        <ul>
                            <li>Mindestens 3 FahrerInnen, nach oben unbeschränkt</li>
                            <li>Mädla, Buaba und gemischt ist möglich und wird zusammen gewertet</li>
                            <li>In der Teamwertung passen wir die Punkte der Mädla an die Buaba an *</li>
                            <li>Es wird jedes Segment jede FahrerIn gewertet</li>
                            <li>Fährt eine FahrerIn nicht, verschlechtert sich der Teamdurchschnitt</li>
                            <li>Melde bis zum 2. Mai deinen Teamnamen und die Links zu allen TeilnehmerInnen an hallo@kesseln.cc</li>
                        </ul>

                        <p><small>* Bei 300 Buaba und 50 Mädla auf einem Segment multiplizieren wir die Punkte der Mädla mit 6</small></p>

                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <h3 id={'corona'}>Warum ist das wichtig während der Corona-Pandemie?</h3>

                        <p>Unser soziales und sportliches Miteinander leidet unter der anhaltenden Kontaktbeschränkung. Es ist wichtig, nach draußen zu gehen und sich zu bewegen.
                            Dadurch bleibst du gesund und stärkst deine Corona-Abwehrkräfte. Durch den virtuellen
                            Wettbewerb wird das spannend und abwechslunsgreich. Dazu bekommst deine tägliche Dosis
                            Motivation und Frustration!</p>
                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">
                        <h3 id={'regelwerk'}>Regelwerk</h3>

                        <p>Damit wir den Wettbewerb fair und sicher durchführen können, ist es wichtig, dass du dich an
                            das Regelwerk hältst. Fahr alleine, betrüge nicht mit Windschatten und halte die
                            Kontaktbeschränkung ein. Riskiere keinen Unfall oder Verletzungen und gibt acht auf andere
                            Verkehrsteilnehmer. Die Rettungskräfte und Krankenhäuser haben wichtigeres zu tun. Verteile
                            Kudos auf Strava – jeder, der sich die Segemente hochquält verdient Respekt!</p>
                    </div>

                </div>

            </div>

            <div className="row justify-content-center mb-5">

                <div className="col-sm-4 mb-5">
                    <img src={Regel1} alt=""/>
                </div>
                <div className="col-sm-4 mb-5">
                    <img src={Regel2} alt=""/>
                </div>
                <div className="col-sm-4 mb-5">
                    <img src={Regel3} alt=""/>
                </div>

            </div>

            <Search updateSearchString={setSearchString} />

            <div className="container">

                <div className="row">

                    <div className="col-12">

                        <h1 className={'mb-3'} id={'gesamtwertung'}>Gesamt&shy;wertung</h1>

                    </div>

                </div>

                <div className={'row mb-5'}>

                    <div className="col-sm-4">
                        <OverallLeaderboard gender={'M'} searchString={searchString}/>
                    </div>

                    <div className="col-sm-4">
                        <OverallLeaderboard gender={'F'} searchString={searchString}/>
                    </div>

                    <div className="col-sm-4">
                        <TeamLeaderboard/>
                    </div>

                </div>

                {segments.map((segment, i) => (

                    <div className={`mb-5 pt-5`} key={i}>

                        <div className={`mb-4`}>

                            <h2 className={'text-danger'} style={{margin: '-1rem', padding: '1rem', overflow: 'hidden'}}>
                                {segment.display
                                    ? <span className={'bg-secondary'} style={{margin: '-1rem', padding: '1rem', whiteSpace: 'nowrap'}}><span className={'d-none d-md-inline'}>Segment {segment.order}: </span><a className={'text-danger' +
                                    ''} href={`https://strava.com/segments/${segment.id}`} target={'_blank'}>{segment.name}</a></span>
                                    : <span className={'bg-secondary'} style={{margin: '-1rem', padding: '1rem'}}>Segment {segment.order}</span>
                                }
                            </h2>

                        </div>

                        <p className={'mb-5'}>
                            {segment.active
                                ? <span><strong>noch {moment.duration(moment().diff(moment(segment.end_date))).humanize()} </strong> bis {moment(segment.end_date).format('dddd H:mm')} Uhr</span>
                                : `von ${moment(segment.start_date).format('dddd, Do MMMM H:mm')} Uhr bis ${moment(segment.end_date).format('dddd, Do MMMM H:mm')} Uhr`
                            }
                        </p>

                        {segment.active && (

                            <Authenticator>

                                <ActivityDropdown segment={segment}/>

                            </Authenticator>

                        )}

                        {segment.display && (

                            <div className={'row'}>

                                <div className="col-md-12 col-lg-4">
                                    <Leaderboard key={segment.id + 'M'} segment={segment.id} gender={'M'} searchString={searchString}/>
                                </div>

                                <div className="col-md-12 col-lg-4">
                                    <Leaderboard key={segment.id + 'F'} segment={segment.id} gender={'F'} searchString={searchString}/>
                                </div>

                                <div className="col-md-12 col-lg-4">
                                    <TeamLeaderboard key={segment.id + 'Team'} segment={segment}/>
                                </div>

                            </div>

                        )}

                    </div>

                ))}

            </div>

            <div className="container">

                <div className="row justify-content-center mb-5">

                    <div className="col-sm-6">

                        <strong>Kesseln Cycling Collective</strong> <br/>
                        &#x68;&#x61;&#x6c;&#x6c;&#x6f;&#x40;&#x6b;&#x65;&#x73;&#x73;&#x65;&#x6c;&#x6e;&#x2e;&#x63;&#x63;
                        <br/>
                        Kronprinzstraße 13 <br/>
                        70173 Stuttgart <br/>

                    </div>

                </div>

            </div>

        </div>

    );
}

export default Home;
